import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { liquidarOperacionFactoring } from "../../utils/factoring";
import { useCurrency } from "../../utils/useCurrency";

const LiquidarFactoringModal = ({ isOpen, onClose, operacion, monedaPrincipal, onSuccess }) => {
  const { formatAmount } = useCurrency();

  const [fechaPagoReal, setFechaPagoReal] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !operacion) return;
    const hoy = new Date().toISOString().split("T")[0];
    setFechaPagoReal(operacion.fecha_cobro_final || hoy);
  }, [isOpen, operacion]);

  const handleLiquidar = async () => {
    if (!fechaPagoReal) return toast.error("Ingresá la fecha de pago real");
    setLoading(true);
    try {
      await liquidarOperacionFactoring(operacion, { fechaPagoReal });
      toast.success("Operación liquidada");
      onSuccess?.();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Error liquidando:", err);
      toast.error("Error al liquidar la operación");
    } finally {
      setLoading(false);
    }
  };

  if (!operacion) return null;

  return (
    <Modal show={isOpen} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "0.95rem" }}>Liquidar — Folio {operacion.factura?.folio || "—"}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <div
          style={{
            padding: "10px 12px",
            marginBottom: 16,
            borderRadius: 6,
            background: "#f8f9fa",
            border: "1px solid #dee2e6",
            fontSize: "0.85rem",
          }}
        >
          <div style={{ marginBottom: 4 }}>
            <strong>Cliente:</strong> {operacion.factura?.razon_social_receptor || "—"}
          </div>
          <div style={{ marginBottom: 4 }}>
            <strong>Monto factura:</strong> {formatAmount(operacion.monto_factura, monedaPrincipal)}
          </div>
          <div style={{ marginBottom: 4 }}>
            <strong>Capital adelantado:</strong> {formatAmount(operacion.capital_adelantado, monedaPrincipal)}
          </div>
          <div style={{ color: "#c0392b" }}>
            <strong>Costo financiero:</strong> {formatAmount(operacion.costo_financiero, monedaPrincipal)}
          </div>
        </div>

        <div style={{ marginBottom: 12, maxWidth: 240 }}>
          <label style={{ fontSize: "0.78rem", fontWeight: 600, display: "block", marginBottom: 4 }}>
            Fecha pago real
          </label>
          <input
            type="date"
            className="form-control form-control-sm"
            value={fechaPagoReal}
            onChange={(e) => setFechaPagoReal(e.target.value)}
            disabled={loading}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="primary" size="sm" onClick={handleLiquidar} disabled={loading}>
          {loading ? "Liquidando..." : "Liquidar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LiquidarFactoringModal;
